import imageCompression from "browser-image-compression";
import { toBase64 } from "./utils";

export const uploadImage = async (file: File | undefined) => {
    const options = {
      maxSizeMB: 3.0, // (max file size in MB)
      maxWidthOrHeight: 1920, // compress the image to this maximum width or height
      useWebWorker: true,
    };
    if (!file) return '';
    try {
      const compressedFile = await imageCompression(file, options);
      return await toBase64(compressedFile);
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error; // Throw the error so it can be caught in the parent scope
    }
  };

  export const validateFileFormat = (file: File) => {
    const allowedExtensionsRegx = /(\.jpg|\.jpeg|\.png)$/i;
    return allowedExtensionsRegx.test(file.name.substring(file.name.lastIndexOf(".")))
  }